import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=1f5e6dfa"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"
import style0 from "./Modules.vue?vue&type=style&index=0&id=1f5e6dfa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports